define(
    'FacetItemsInfo2.View'
    , [
        'SCView',
        'facetitemsinfo2.tpl'
    ]
    , function (
        SCViewModule,
        facetItemsInfo2_tpl
    ) {
    
    'use strict';

    var SCView = SCViewModule.SCView;

    var secondFacetItemField = '';

    function FacetItemsInfo2View(options) {

        SCView.call(this, options);
        this.template = facetItemsInfo2_tpl;
        this.contextDataRequest = ['item'];
        this.config = options.Data;

    }

    FacetItemsInfo2View.prototype = Object.create(SCView.prototype);
    FacetItemsInfo2View.prototype.constructor = FacetItemsInfo2View;

    FacetItemsInfo2View.prototype.getContext = function () {

        var itemField = this.config.itemfieldsTwo;
        secondFacetItemField = this.contextData.item()[itemField];

        return {

            source: secondFacetItemField
        };
    }

    return FacetItemsInfo2View;
});
